module.exports = __webpack_public_path__ + "img/md-worker.1c7c262a.jpeg";